
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, ButtonGroup, Card, Grid, IconButton, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { CustomTooltipBlack } from '../Tooltip/CustomTooltip';
import SubjectTooltipTable from '../Table/SubjectTooltipTable';
import { agendaSubjectCardColor } from 'config';
import { subjectCardTextColor } from 'config';
import { transformGroups } from 'app/utils/appHelpers';
import AgendaCard from './AgendaCard';

function AgendaSubjectCard({
    subjectId,
    agendas,
    index,
    subjectGroups,
    handleSubjectSorting,
    handleAgendaSorting,
    handleDelete,
    sxOverride = {},
    type = "normal",
    isExtra = false

}) {
    const subjectList = useSelector(state => state.subject.data || []);
    const subjectName = type === "supp" ? "Ek Gündemler" : subjectList.find(item => item.id === Number(subjectId))?.name || "Tanımsız Konu";
    const agendasCount = agendas.length;
    const lastAgendaDecisionNo = agendas[0]?.decisionNo + agendasCount - 1;
    const firstAgendaDecisionNo = agendas[0]?.decisionNo;

    const subjectLookup = (subjectId) => {
        const subject = subjectList.find((item) => item.id === Number(subjectId));
        return subject ? subject.name : null;
    };

    const tooltipList = transformGroups(subjectGroups, subjectLookup);    return (
        <Card
            sx={{
                m: '5px',
                p: 0,
                backgroundColor: agendaSubjectCardColor,
                borderRadius: 2,
                ...sxOverride
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    m: 0,
                    p: 0,
                }}
            >
                <Grid
                    container
                    spacing={0}
                    sx={{ m: 0, p: 0, alignItems: 'center' }}
                >
                    <Grid item xs={1}>
                        {isExtra || type === 'supp' ? null : (
                            <ButtonGroup>
                                <IconButton
                                    onClick={() => handleSubjectSorting(index, 'up')}
                                    disabled={index === 0}
                                >
                                    <ArrowUpwardIcon />
                                </IconButton>
                                <IconButton
                                    onClick={() => handleSubjectSorting(index, 'down')}
                                    disabled={index === subjectGroups.length - 1}
                                >
                                    <ArrowDownwardIcon />
                                </IconButton>
                            </ButtonGroup>
                        )}
                    </Grid>
                    <Grid item xs={10}>
                        <CustomTooltipBlack
                            placement="top"
                            arrow
                            title={
                                <SubjectTooltipTable tooltipList={tooltipList} />
                            }
                        >
                            <Typography
                                sx={{
                                    m: 0,
                                    p: 0,
                                    textAlign: 'center',
                                    color: type === 'supp' ? 'error.main' : subjectCardTextColor,
                                    fontWeight: type === 'supp' ? 600 : 450,
                                }}
                            >
                                {subjectName} / Gündem Sayısı: {agendasCount}
                            </Typography>
                        </CustomTooltipBlack>
                    </Grid>
                    <Grid item xs={1} />
                </Grid>
                {agendas.map((agenda, agendaIndex) => (
                    <AgendaCard
                        key={agenda.id}
                        agenda={agenda}
                        index={agendaIndex}
                        agendas={agendas}
                        handleAgendaSorting={(agendaIndex, agenda, direction) =>
                            handleAgendaSorting(subjectId, agendaIndex, direction, agenda)
                        }
                        maxDecisionNo={lastAgendaDecisionNo}
                        minDecisionNo={firstAgendaDecisionNo}
                        handleDelete={handleDelete}
                    />
                ))}
            </Box>
        </Card >
    );
}
export default AgendaSubjectCard;